var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"external_view_questionnaire"},[(_vm.show)?_c('CommonQuestionnaire',{ref:"commonQuestionnaire",attrs:{"autoid":_vm.mautoid,"username":_vm.username}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }